export class ReportePuntoVisitaCertificadoDistancia {
    public idCompania: string;
    public idVisita: string;
    public idPunto: string;
    public nombrePunto: string;
    public direccion: string;
    public longitud: string;
    public latitud: string;
    public longitudCertificacion: string;
    public latitudCertificacion: string;
    public distancia: string;
}

 